import { CONSTANTS } from "src/constants";
import {
  ReferralCategoriesAssign,
  ReferralCategoriesPatch,
  ReferralCategoriesPost,
} from "src/models/referrals.models";
import { urlReplace } from "src/utils/common.utils";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function createReferralCategory(payload: ReferralCategoriesPost) {
  return await apiCall.post(
    payload?.parent_category_uuid
      ? API_URL.REFERRAL_MANAGEMENT.CREATE_REFERRAL_SUB_CATEGORIES
      : API_URL.REFERRAL_MANAGEMENT.CREATE_REFERRAL_CATEGORIES,
    payload
  );
}

export async function getReferralCategory() {
  return await apiCall.get(API_URL.REFERRAL_MANAGEMENT.GET_REFERRAL_CATEGORIES);
}
export async function getReferralSubCategory(uuid: string) {
  const url = urlReplace(
    API_URL.REFERRAL_MANAGEMENT.GET_REFERRAL_SUB_CATEGORIES,
    CONSTANTS.PARENT_CATEGORY_UUID,
    uuid
  );
  return await apiCall.get(url);
}
export async function mapReferralCategory(payload: ReferralCategoriesAssign) {
  return await apiCall.patch(
    API_URL.REFERRAL_MANAGEMENT.MAP_REFERRAL_CATEGORIES,
    payload
  );
}

export async function updateReferralCategory(payload: ReferralCategoriesPatch) {
  const url = urlReplace(
    API_URL.REFERRAL_MANAGEMENT.UPDATE_REFERRAL_CATEGORIES,
    CONSTANTS.CATEGORY_UUID,
    payload.uuid
  );
  return await apiCall.patch(url, { disable: payload.disable });
}
